import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  TextField,
} from "@mui/material";
import { useApiClient } from "../api";

export const TagAutocomplete = ({
  value,
  onChange,
  subject,
  educationLevel,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const ApiClient = useApiClient();
  useEffect(() => {
    let active = true;

    const fetch = async () => {
      if (!inputValue.trim()) return;

      setLoading(true);
      try {
        const params = { query: inputValue };
        if (subject?.id) params.subject = subject.id;
        if (educationLevel?.id) params.educationLevel = educationLevel.id;

        const results = await ApiClient.core.searchTags(params);
        if (active) {
          setOptions(results.map((tag) => tag.tag));
        }
      } catch (error) {
        console.error("Tag search failed", error);
      } finally {
        setLoading(false);
      }
    };

    const timeout = setTimeout(fetch, 300); // debounce

    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [inputValue, subject, educationLevel]);

  return (
    <FormControl fullWidth>
      <Autocomplete
        multiple
        freeSolo
        options={options}
        value={value}
        onChange={(e, newValue) => onChange(newValue)}
        inputValue={inputValue}
        onInputChange={(e, newInputValue, reason) => {
          if (reason === "reset") return;
          setInputValue(newInputValue || "");
        }}
        loading={loading}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiInputBase-root": {
                minHeight: 80,
                alignItems: "flex-start",
                flexWrap: "wrap",
              },
              "& .MuiInputBase-input": {
                minWidth: 50,
              },
            }}
            label={"Tags"}
            onKeyDown={(e) => {
              if (e.key === "," || e.key === "Enter") {
                const raw = inputValue.trim();
                if (raw) {
                  e.preventDefault();
                  const newTag = raw.replace(/,$/, "");
                  if (newTag && !(value || []).includes(newTag)) {
                    onChange([...(value || []), newTag]);
                  }
                  setInputValue("");
                }
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress size={18} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};
